import React, { Component } from 'react'
import { Spin } from 'antd'

type PropsType = {
    transparent?: boolean
    contained?: boolean
}

export default class Preloader extends Component<PropsType> {
    render() {
        const cls = 'preloader'
            + (this.props.transparent ? ' preloader__transparent' : '')
            + (this.props.contained ? ' preloader__contained' : '')

        return (
        <div className={cls}>
            <div className='preloader_spinner'>
                <Spin />
            </div>
        </div>
        )
    }
}
